export const SET_B2C_BUS_LIST = "SET_B2C_BUS_LIST";

export function setB2CBusList(payload) {
  return {
    type: SET_B2C_BUS_LIST,
    payload,
  };
}
